import {useMemo} from "react";
import {useRemoteData} from "../../common/utils/useRemoteData";
import {fetchRelatedProducts} from "../../features/catalog/infrastructure/CatalogService";
import {mapRemoteData} from "../../common/domain/RemoteData.model";

export const useRelatedProducts = (productCode) => {

    const fetchFn = useMemo(() =>
        () => fetchRelatedProducts(productCode, {amount: 50, page: 0})
                .then(rd => mapRemoteData(rd, ({content}) => content)),
        [productCode]
    );

    const relatedProductsRemoteData = useRemoteData(
        {
            initial: null,
            dataFetchingCallback: fetchFn
        });

    return {relatedProductsRemoteData};
};
